import { handleGqlResponseBody } from '@/utils/apollo.util'
import {
  GET_MANAGE_NOTIFICATIONS_QUERY,
  GET_MANAGE_NOTIFICATION_DETAIL_QUERY
} from '@/graphql/queries/notification/notification.query'
import {
  CREATE_NOTIFICATION_MUTATION,
  UPLOAD_NOTIFICATION_ATTACHMENT_MUTATION
} from '@/graphql/mutations/notification/notification.mutation'

const notification = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getManageNotificationsQuery (_ctx, { propertyId, skip, take }) {
      return handleGqlResponseBody(apollo => {
        return apollo.query({
          query: GET_MANAGE_NOTIFICATIONS_QUERY,
          variables: { propertyId: propertyId ?? null, skip, take },
          fetchPolicy: 'no-cache'
        })
      })
    },
    async getManageNotificationDetailQuery (_ctx, { id }) {
      return handleGqlResponseBody(apollo => {
        return apollo.query({
          query: GET_MANAGE_NOTIFICATION_DETAIL_QUERY,
          variables: { id },
          fetchPolicy: 'no-cache'
        })
      })
    },
    async uploadNotificationAttachment (_ctx, { file }) {
      return handleGqlResponseBody(apollo => {
        return apollo.mutate({
          mutation: UPLOAD_NOTIFICATION_ATTACHMENT_MUTATION,
          variables: { data: { file } }
        })
      })
    },
    async createNotification (_ctx, {
      propertyId, roomIds, title, body, attachments
    }) {
      return handleGqlResponseBody(apollo => {
        return apollo.mutate({
          mutation: CREATE_NOTIFICATION_MUTATION,
          variables: {
            data: {
              propertyId,
              roomIds,
              title,
              body,
              attachments
            }
          }
        })
      })
    }
  }
}

export default notification
